import { render } from "./ProductCard.vue?vue&type=template&id=52021983&scoped=true"
import script from "./ProductCard.vue?vue&type=script&lang=js"
export * from "./ProductCard.vue?vue&type=script&lang=js"

import "./ProductCard.vue?vue&type=style&index=0&id=52021983&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging-logistic.hoornbloommasters.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52021983"]])

export default __exports__